import ChatbotModel from '@mm/state/model/ChatbotModel';
import WidgetModel from '@mm/state/model/WidgetModel';
import React, { MutableRefObject, useState } from 'react';
import {
  ADS_TYPES_ARRAY,
  INSTAGRAM_REPLY_TYPES_ARRAY,
  SMS_OPTIN_TYPES_ARRAY,
  SMS_REPLY_TYPES_ARRAY,
  TYPES,
  TYPES_ARRAY,
} from '../../../../editor/features/build/components/widgets/constants/quickQuestion';
import PrimarySelect, {
  DropdownOption,
} from '../../../components/PrimarySelect/PrimarySelect';
import {
  getQQUserResponseType,
  useQQWidgetHandlers,
} from '../../../helpers/widget-helpers/use-qq-widget-handlers';
import './QuestionReplyType.pcss';

type Props = {
  quickQuestion: WidgetModel;
  qqResponseType: string;
  bot: ChatbotModel;
  editMode: boolean;
  setEditMode: (editMode: boolean) => void;
  setIsChangingResponseType: (isChangingResponseType: boolean) => void;
  questionReplyTypeHotSpotRef: MutableRefObject<HTMLDivElement | null>;
  forAds?: boolean;
  isSmsReply: boolean;
  isSmsOptIn: boolean;
  onChange?: (type: DropdownOption) => any;
  forInstagram?: boolean;
  usedInSlideout?: boolean;
};

export const getDropdownOption = (
  quickQuestion: WidgetModel,
  forAds?: boolean,
  forInstagram?: boolean,
) => {
  const types = forAds
    ? ADS_TYPES_ARRAY
    : forInstagram
    ? INSTAGRAM_REPLY_TYPES_ARRAY
    : TYPES_ARRAY;
  const defaultType = forAds
    ? ADS_TYPES_ARRAY[1]
    : forInstagram
    ? INSTAGRAM_REPLY_TYPES_ARRAY[0]
    : TYPES_ARRAY[2];
  const responseType = getQQUserResponseType(quickQuestion);
  return types.find(type => type.name === responseType) || defaultType;
};

const RESPONSE_TYPE_TEXT = {
  [TYPES.PHONE]: 'phone number',
  [TYPES.EMAIL]: 'email',
  [TYPES.TEXT]: 'text',
  [TYPES.MULTIPLE]: 'one of the choices above',
};

export const QuestionReplyType = (props: Props) => {
  const {
    forAds,
    quickQuestion,
    qqResponseType,
    editMode,
    setIsChangingResponseType,
    setEditMode,
    questionReplyTypeHotSpotRef,
    isSmsReply,
    isSmsOptIn,
    forInstagram,
    onChange,
    usedInSlideout,
  } = props;

  const qqWidgetHandlers = useQQWidgetHandlers();
  const [selectedType, setSelectedType] = useState<DropdownOption>(
    getDropdownOption(quickQuestion, forAds),
  );

  const onChangeType = async (selectedType: DropdownOption) => {
    setIsChangingResponseType(true);
    setSelectedType(selectedType);
    await qqWidgetHandlers.onChangeResponseType(
      quickQuestion,
      selectedType.name || '',
    );
    onChange?.(selectedType);
    setIsChangingResponseType(false);
  };

  // Note: disabled as part of https://mobilemonkey.atlassian.net/browse/MM-5303
  // if (!editMode) {
  if (true) {
    const previewResponseTypeText =
      RESPONSE_TYPE_TEXT[qqResponseType] || RESPONSE_TYPE_TEXT[TYPES.TEXT];

    return (
      <div
        className="question-reply-type"
        onClick={() => {
          setEditMode(true);
        }}
      >
        <div className="question-reply-type__preview-text">
          User replies with {previewResponseTypeText}
        </div>
      </div>
    );
  }

  let options = TYPES_ARRAY;
  if (isSmsReply) {
    options = SMS_REPLY_TYPES_ARRAY;
  } else if (isSmsOptIn) {
    options = SMS_OPTIN_TYPES_ARRAY;
  } else if (forAds) {
    options = ADS_TYPES_ARRAY;
  } else if (forInstagram) {
    options = INSTAGRAM_REPLY_TYPES_ARRAY;
  }

  return (
    <>
      <div className="question-reply-type" ref={questionReplyTypeHotSpotRef}>
        <div className="question-reply-type__user-replies-text">
          User replies with
        </div>

        <div className="question-reply-type__select-container">
          <PrimarySelect
            options={options}
            value={selectedType}
            disabled={isSmsOptIn || isSmsReply}
            onChange={onChangeType}
            className="question-reply-type__select"
            customDropdownStyles={{
              zIndex: usedInSlideout ? '1000003' : '999',
            }}
          />
        </div>
      </div>
    </>
  );
};
